import { networkLogos } from 'src/constants/networkLogos'
import { leagueLogos } from 'src/constants/leagueLogos'
import { championshipLogos } from './championshipLogos'
import { conferenceLogos } from './conferenceLogos'

export const networkSets = {
  default: [
    networkLogos.abc,
    networkLogos.cbs,
    networkLogos.fox,
    // TEMPORARY NBC DISPUTE
    // networkLogos.nbc,
    networkLogos.abcnews,
    networkLogos.espn,
    networkLogos.fx,
    networkLogos.fs1,
  ],
  // Baseball (MLB)
  baseball: [
    // MLB.TV
    networkLogos.mlbtv,
    // FOX
    networkLogos.fox,
    // ESPN
    networkLogos.espn,
    // FOX Sports 1
    networkLogos.fs1,
    // RSN's
    // MLB Network
    networkLogos.mlbnetwork,
    networkLogos.cbs,
    // ESPN2
    networkLogos.espn2,
  ],
  // Football (NFL, college)
  football: [
    // FOX
    networkLogos.fox,
    // NFL Network
    networkLogos.nflnetwork,
    // CBS
    networkLogos.cbs,
    // NBC
    // TEMPORARY NBC DISPUTE
    // networkLogos.nbc,
    networkLogos.nbatv,
    // ESPN
    networkLogos.espn,
    // ACC Network
    networkLogos.acc,
    // SEC Network
    networkLogos.sec,
  ],
  // Football (NFL, college)
  collegeFootball: [
    // ACC Network
    networkLogos.acc,
    // SEC Network
    networkLogos.sec,
    // Big Ten
    networkLogos.bigten,
    // ESPN
    networkLogos.espn,
    // FOX
    networkLogos.fox,
    // NBC
    // TEMPORARY NBC DISPUTE
    // networkLogos.nbc,
    networkLogos.nbatv,
    // Pac-12
    networkLogos.nflnetwork,
  ],
  nfl: [
    // NFL Network
    networkLogos.nflnetwork,
    // NFL Network
    networkLogos.nflredzone,
    // ESPN
    networkLogos.espn,
    // CBS
    networkLogos.cbs,
    // FOX
    networkLogos.fox,
    // NBC
    // TEMPORARY NBC DISPUTE
    // networkLogos.nbc,
    networkLogos.nbatv,
    // B1G Network
    networkLogos.bigten,
  ],

  // Basketball (NBA, college)
  basketball: [
    // ESPN
    networkLogos.espn,
    // ABC
    networkLogos.abc,
    // NBA TV
    networkLogos.nbatv,
    // CBSSN
    networkLogos.cbs,
    // Pac-12
    networkLogos.nflnetwork,
    // ACC Network
    networkLogos.acc,
    // SEC Network
    networkLogos.sec,
    // Stadium
  ],

  // Basketball (NBA, college)
  womensBasketball: [
    // ESPN
    networkLogos.espn,
    // CBSSN
    networkLogos.cbs,
    // ION
    networkLogos.ion,
    // NBA TV
    networkLogos.nbatv,
    // ACC Network
    networkLogos.acc,
    // SEC Network
    networkLogos.sec,
    // ESPN2
    // Pac-12
    networkLogos.abc,
    // Stadium
  ],

  // Soccer (all coverage, non-Latino)
  soccer: [
    // ESPN
    networkLogos.espn,
    // ABC
    networkLogos.abc,
    // FS1
    networkLogos.fs1,
    // USA Network
    // TEMPORARY NBC DISPUTE
    // networkLogos.usa,
    networkLogos.nbatv,
    // FS2, but I replace with Bein
    networkLogos.bein,

    //REMOVED: univision_removed tudn
    // ESPNU
    // networkLogos.tudn,
    //REPLACED: univision_removed, espndeportes
    networkLogos.espndeportes,

    // ESPN2, but I replace with GolTV
    networkLogos.goltv,
  ],

  hockey: [
    networkLogos.espn,
    networkLogos.abc,
    networkLogos.fs1,
    // TEMPORARY NBC DISPUTE
    // networkLogos.usa,
    networkLogos.nbatv,
    networkLogos.cbs,
    networkLogos.bein,
    //REMOVED: univision_removed, tudn
    // networkLogos.tudn,
    //REPLACED: univision_removed, espndeportes
    networkLogos.espndeportes,
  ],

  // Misc Sports not covered by other categories
  sports: [
    networkLogos.espn,
    networkLogos.fs1,
    // TEMPORARY NBC DISPUTE
    // networkLogos.usa,
    networkLogos.nbatv,
    networkLogos.bein,
    networkLogos.nflnetwork,
    //REMOVED: univision_removed tudn
    // networkLogos.tudn,
    //REPLACED: univision_removed, espndeportes
    networkLogos.espndeportes,
    networkLogos.cbs,
  ],

  // Entertainment
  entertainment: [
    // ABC (Grey’s Anatomy, The Bachelor/Bachelorette, Abbott Elementary, American Idol)
    networkLogos.abc,
    // CBS (NCIS, FBI, Young Sheldon, Survivor)
    networkLogos.cbs,
    // NBC (Law & Order: SVU, Young Rock, America's Got Talent, The Voice)
    // TEMPORARY NBC DISPUTE
    // networkLogos.nbc,
    networkLogos.ion_mystery,
    // FOX (Masterchef, Beat Shazam, So You Think You Can Dance, Family Guy)
    networkLogos.fox,
    networkLogos.fx,
    networkLogos.espn,
    networkLogos.freeform,
  ],
  // News
  news: [
    // Fox News
    networkLogos.foxnews,
    // MSNBC
    // TEMPORARY NBC DISPUTE
    // networkLogos.msnbc,
    networkLogos.lawcrime,
    // ABC News
    networkLogos.abcnews,
    // Fox Business
    networkLogos.foxbusiness,
    // CBS News
    networkLogos.cbsnews,
    // Young Turks?
    networkLogos.tyt,
    // Weather Channel
    networkLogos.weatherchannel,
    // TBD
  ],
  // Latino Soccer (all coverage)
  soccerLatino: [
    //REMOVED: univision_removed, tudn
    // TUDN
    // networkLogos.tudn,

    // beIN SPORTS
    networkLogos.bein,
    // FOX Deportes
    networkLogos.foxdeportes,
    // ESPN Deportes
    networkLogos.espndeportes,
    // Gol TV
    networkLogos.goltv,
    // TyC Sports
    networkLogos.tyc,
    // Univision
    //REMOVED: univision_removed, univision
    // networkLogos.univision,

    //REPLACED: univision_removed, telemundo networks
    // TEMPORARY NBC DISPUTE
    // networkLogos.telemundo_noticias_ahora,
    // networkLogos.telemundo_accion,
    networkLogos.paramount,
    networkLogos.nbatv,

    // FSN Latino
    // networkLogos.fsnlatino,
  ],
  // Latino Entertainment and Soccer (all coverage)
  entertainmentLatino: [
    networkLogos.espndeportes,
    // FOX Deportes
    networkLogos.foxdeportes,
    // beIN SPORTS
    networkLogos.bein,
    // Gol TV
    networkLogos.goltv,
    // TyC Sports
    networkLogos.tyc,
    //REPLACED: univision_removed, telemundo networks
    // Telemundo Noticias Ahora
    // TEMPORARY NBC DISPUTE
    // networkLogos.telemundo_noticias_ahora,
    networkLogos.nbatv,

    // Nuestra Tele
    networkLogos.nuestratele,
  ],
  // Canada WITH Premium
  canada: [
    // Home Network
    networkLogos.home_network,
    // Flavour Network
    networkLogos.flavour_network,
    // Global Television
    networkLogos.global,
    // Disney
    networkLogos.disney,
    // Teletoon
    networkLogos.cartoonnetwork,
    // Treehouse
    networkLogos.treehouse,
    // W Network
    networkLogos.wnetwork,
  ],
  // Canada Essentials
  canadaEssentials: [
    // PL
    leagueLogos.pl,
    // Serie A
    leagueLogos.seriea,
    // Coppa Italia
    leagueLogos.coppaitalia,
    // beIN SPORTS
    networkLogos.bein,
    // NBC News Now
    //TEMPORARY NBC DISPUTE
    // networkLogos.nbc_news_now,
    networkLogos.real_madrid_tv,
    // Paramount Network
    networkLogos.onesoccer,
    // MLB Network
    networkLogos.mlbnetwork,
  ],
  canada_sports: [
    networkLogos.fsn,
    leagueLogos.pl,
    leagueLogos.seriea,
    leagueLogos.coppaitalia,
    networkLogos.bein,
    //TEMPORARY NBC DISPUTE
    // networkLogos.nbc_news_now,
    networkLogos.real_madrid_tv,
    networkLogos.onesoccer,
  ],
  canada_news: [
    //TEMPORARY NBC DISPUTE
    // networkLogos.dateline,
    networkLogos.chch,
    networkLogos.tastemade,
    networkLogos.cheddar_news,
    networkLogos.lawcrime,
    networkLogos.forensic_files,
    //TEMPORARY NBC DISPUTE
    // networkLogos.nbc_news_now,
    networkLogos.real_madrid_tv,

    networkLogos.newsmax,
  ],

  svod: [
    networkLogos.abcnews,
    networkLogos.foxlivenow,
    networkLogos.kitchennightmares,
    networkLogos.fsn,
    networkLogos.lawcrime,
    networkLogos.cleotv,
    networkLogos.gettv,
    networkLogos.bkfctv,
    networkLogos.tennischannel,
    networkLogos.gameshowcentral,
  ],
  golf: [
    championshipLogos.the_players,
    championshipLogos.masters_tournament,
    championshipLogos.pga,
    championshipLogos.us_open,
    championshipLogos.the_open,
  ],
  zeeFamily: [
    networkLogos.willow,
    networkLogos.willow_extra,
    networkLogos.zee_tv,
    networkLogos.zee_cinema,
    networkLogos.zee_bollywood,
    networkLogos.zee_classic,
    networkLogos['&tv'],
  ],
  canada_cricket: [
    networkLogos.nbatvca,
    networkLogos.bigten,
    networkLogos.fox_sports_racing,
    // TEMPORARY NBC DISPUTE
    // networkLogos.nbc_news_now,
    networkLogos.real_madrid_tv,
    networkLogos.cheddar_news,
    networkLogos.tastemade,
    networkLogos.lawcrime,
  ],
  canada_dazn: [
    networkLogos.fsn,
    networkLogos.dazn,
    networkLogos.onesoccer,
    networkLogos.bein,
    // TEMPORARY NBC DISPUTE
    // networkLogos.nbc_news_now,

    networkLogos.chch,
    networkLogos.real_madrid_tv,
  ],
  latino_leagues: [
    leagueLogos.laliga,
    leagueLogos.seriea_w_network,
    leagueLogos.ligaMX,
    leagueLogos.betplay,
    leagueLogos.liberatores,
  ],
  cfb_conference_logos: [
    conferenceLogos.aac,
    conferenceLogos.acc,
    conferenceLogos.b10,
    conferenceLogos.big12,
    conferenceLogos.cusa,
    conferenceLogos.pac12,
    conferenceLogos.sec,
  ],
  fubo_sports: [
    networkLogos.abc,
    networkLogos.cbs,
    networkLogos.fox,
    networkLogos.espn,
    networkLogos.fs1,
    networkLogos.nflnetwork,
    networkLogos.sec,
  ],
  fubo_sports_hockey: [
    networkLogos.abc,
    networkLogos.espn,
    networkLogos.nhlnetwork,
    networkLogos.fox,
    networkLogos.fs1,
    networkLogos.espnplus,
    networkLogos.cbssports,
  ],
  standalone_networks: [
    networkLogos.foxlivenow,
    networkLogos.abc_2020,
    networkLogos.abcnews,
    networkLogos.dateline,
    networkLogos.grit,
    networkLogos.ion_mystery,
    networkLogos.fsn,
  ],
}
